import React, { useEffect, useState } from 'react';
import { BarChart3, Users, Clock, Calendar, UserX, CalendarDays, ListChecks, TimerReset, FolderKanban } from 'lucide-react';
import API from '../../api'; // your axios instance
import { Link } from 'react-router-dom';
import {API_IMAGE_URL2} from '../../lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
   const [absentees, setAbsentees] = useState([]);
   const [lateArrivals, setLateArrivals] = useState([]);

  useEffect(() => {
    Promise.all([
      API.get('/admin/stats'),
      API.get('/admin/activities/recent'),
      API.get('/admin/absentees'), 
      API.get('/admin/late-arrivals'), // 👈 Add this
    ])
      .then(([statsRes, activitiesRes, absenteesRes, lateRes]) => {
        setStats(statsRes.data);
        console.log(activitiesRes);
        setActivities(activitiesRes.data.activities); // <-- Fix: use .activities here
         setAbsentees(absenteesRes.data.absentees || []);
           setLateArrivals(lateRes.data.lateArrivals || []); // 👈 Set late arrivals
        setLoading(false);
        console.log(activities);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center p-4">Loading...</p>;

const cards = [
    { icon: <CalendarDays className="w-6 h-6 text-purple-600" />, label: 'Today Followup', value: stats.today_followup_count, path: '/dashboard/today-followup' },
  { icon: <ListChecks className="w-6 h-6 text-indigo-600" />, label: 'Followup', value: stats.followup_count, path: '/dashboard/followup-list' },
  { icon: <TimerReset className="w-6 h-6 text-yellow-600" />, label: 'Pending Project', value: stats.pending_project_count, path: '/dashboard/due-customer' },
  { icon: <FolderKanban className="w-6 h-6 text-teal-600" />, label: 'Total Project', value: stats.total_project_count, path: '/dashboard/total-customer' },
  
  { icon: <Users className="w-6 h-6 text-blue-600" />, label: 'Total Employees', value: stats.total_employees, path: '/dashboard/employee-management' },
  { icon: <Clock className="w-6 h-6 text-green-600" />, label: 'Present Today', value: stats.present_today, path: '/dashboard/employee-attendance' },
  { icon: <Calendar className="w-6 h-6 text-orange-600" />, label: 'Pending Leaves', value: stats.pending_leaves, path: '/dashboard/leave-management' },
  { icon: <Clock className="w-6 h-6 text-red-600" />, label: 'Late Arrivals', value: stats.late_arrivals, path: '/dashboard/employee-attendance' },

  // New cards with paths (replace paths with your real routes)

];


  return (
    <div className="space-y-6 p-6 bg-gray-50 min-h-screen">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <BarChart3 className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
      </div>

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
  {cards.map((c, idx) => (
    <Link 
      to={c.path || '#'} 
      key={idx} 
      className="bg-white rounded-xl shadow-lg p-6 flex items-center space-x-4 hover:bg-gray-100 transition"
    >
      <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-gray-100">
        {c.icon}
      </div>
      <div>
        <h3 className="text-sm font-medium text-gray-500">{c.label}</h3>
        <p className="text-2xl font-bold text-gray-900">{c.value ?? '–'}</p>
      </div>
    </Link>
  ))}
</div>

 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
<div className="bg-white rounded-xl shadow-lg p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <UserX className="w-5 h-5 text-red-600" /> Absent Today
        </h2>
        {absentees.length === 0 ? (
          <p className="text-gray-500">All employees have marked attendance.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {absentees.map((emp) => (
              <div key={emp.id} className="flex items-center bg-gray-50 p-3 rounded-lg shadow-sm">
                <img
                  src={`${API_IMAGE_URL2}${emp.profile_image}` || '../../../public/logo192.png'}
                  alt={emp.full_name}
                  className="w-10 h-10 rounded-full object-cover mr-3"
                />
                <div>
                  <p className="text-sm font-medium text-gray-800">{emp.full_name}</p>
                  <p className="text-xs text-gray-500">{emp.department || 'No department'}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

{/* 👇 Late Arrivals */}
<div className="bg-white rounded-xl shadow-lg p-6">
  <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
    <Clock className="w-5 h-5 text-yellow-600" /> Late Arrivals Today
  </h2>
  {lateArrivals.length === 0 ? (
    <p className="text-gray-500">No late arrivals today.</p>
  ) : (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {lateArrivals.map((emp, i) => (
        <div key={i} className="flex items-center bg-gray-50 p-3 rounded-lg shadow-sm">
          <img
            src={`${API_IMAGE_URL2}${emp.profile_image}` || '/default-profile.png'}
            alt={emp.full_name}
            className="w-10 h-10 rounded-full object-cover mr-3"
          />
          <div>
            <p className="text-sm font-medium text-gray-800">{emp.full_name}</p>
            <p className="text-xs text-gray-500">
              {emp.department || 'No department'} — Entry: {emp.entry_time?.slice(0, 5)}
            </p>
          </div>
        </div>
      ))}
    </div>
  )}
</div>
 </div>



<div className="bg-white rounded-xl shadow-lg p-6">
  <h2 className="text-xl font-semibold text-gray-900 mb-4">Recent Activities</h2>
  {activities.length === 0 && <p className="text-gray-500">No recent activity.</p>}
  {activities.map((act, i) => (
    <div key={i} className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg mb-2">
      <span className="w-2 h-2 rounded-full bg-green-500"></span>

      {/* Profile Image */}
      <img 
        src={`${API_IMAGE_URL2}${act.profileImage}` || '/default-profile.png'} 
        alt={act.employeeName} 
        className="w-8 h-8 rounded-full object-cover border border-gray-300" 
      />

      <div>
        {/* Employee Name */}
        <p className="text-sm font-semibold text-gray-900">{act.employeeName} - ({act.message})</p>
        {/* Activity message */}
     
        {/* Time */}
        <p className="text-xs text-gray-500">{new Date(act.time).toLocaleString()}</p>
      </div>
    </div>
  ))}
</div>

    </div>
  );
}
